import { Store } from "store";
import { lockAccount } from "store/actions/account";

import { ErrorCodes } from "../types/error.types";

export type GlobalErrorCallback = (store: Store) => void;

export const globalErrors: Partial<Record<ErrorCodes, GlobalErrorCallback>> = {
  BLOCKED: store => {
    store.dispatch(lockAccount("BLOCKED"));
  },
};
